import React, { forwardRef } from 'react';
import {
  TextField,
  InputAdornment,
  MenuItem,
  Select,
  RadioGroup,
  Radio,
  FormControlLabel,
  Box,
  Checkbox,
  Card,
  useTheme,
  IconButton,
} from '@material-ui/core';
import ImageUploading from 'react-images-uploading';
import ClearIcon from '@material-ui/icons/Clear';
// import UpdateIcon from '@material-ui/icons/Update';
import SvgIconML from '@/components/SvgIconML/SvgIconML';

let timer = null;
export const TextFieldCom = forwardRef(
  (
    {
      errors,
      queryType,
      pr,
      label,
      showLabel = true,
      id,
      helperText = '',
      setValue,
      resetPrize,
      guid,
      restKey,
      isPositiveNumber = false,
      errorText,
      pId,
      endAdornment = null,
      isParseInt = false,
      ...props
    },
    ref,
  ) => {
    let text = '';
    if (errors[id]) {
      if (errorText) {
        text = errorText;
      } else {
        text = `${label}是必填项`;
      }
    } else if (helperText) {
      text = helperText;
    }
    return (
      <TextField
        sx={{ width: '100%' }}
        ref={ref}
        variant="standard"
        autoComplete="off"
        label={
          showLabel && label ? (
            <>
              <span style={{ color: 'red' }}>*</span> {label}
            </>
          ) : (
            ''
          )
        }
        {...props}
        className="text-input-style"
        onChange={(e) => {
          clearTimeout(timer);
          timer = setTimeout(() => {
            resetPrize && resetPrize(guid, restKey, e.target.value, pId);
          }, 1000);
          let v = e.target.value;
          if (isPositiveNumber) {
            if (isNaN(v)) {
              v = '';
            }
            v = v.replace(/-/g, '');
          }
          if (isParseInt) {
            // eslint-disable-next-line radix
            v = v.replace(/\D/g, '');
          }
          return pr.onChange(v);
        }}
        // onBlur={(e) => {}}
        error={Boolean(errors[id])}
        helperText={text}
        disabled={queryType === 'detail'}
        value={pr.value ?? ''}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                className="clear-btn"
                onClick={() => {
                  // reset({title: ''});
                  resetPrize && resetPrize(guid, restKey, '', pId);
                  setValue(id, '');
                }}
                edge="end"
                disabled={queryType === 'detail'}
              >
                {(pr.value || pr.value === 0 || pr.value === '0') && (
                  <ClearIcon className="clear-icon" />
                )}
              </IconButton>
              {endAdornment && (
                <span
                  style={{
                    fontSize: '12px',
                    color: '#404041',
                    marginLeft: '4px',
                  }}
                >
                  {endAdornment}
                </span>
              )}
            </InputAdornment>
          ),
        }}
      />
    );
  },
);

export const SelectFieldCom = forwardRef(
  (
    {
      queryType,
      pr,
      typeList = [],
      onSetContent,
      label,
      value = 0,
      resetPrize,
      guid,
      restKey,
      disabled,
      ...props
    },
    ref,
  ) => {
    return (
      <Select
        ref={ref}
        {...props}
        disabled={queryType === 'detail' || disabled}
        onChange={(e) => {
          onSetContent && onSetContent(e.target.value);
          resetPrize && resetPrize(guid, restKey, e.target.value);
          return pr.onChange(e.target.value);
        }}
        value={pr.value ?? value}
        label={label ? label : ''}
      >
        {typeList.map((item) => (
          <MenuItem key={item.value} value={item.value}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
    );
  },
);

export const RadioFieldCom = forwardRef(
  (
    { queryType, pr, typeList = [], lWidth, children, row = true, ...props },
    ref,
  ) => {
    return (
      <RadioGroup
        aria-label="gender"
        {...props}
        {...pr}
        value={pr.value ?? 0}
        ref={ref}
        onChange={(e) => {
          return pr.onChange(e.target.value);
        }}
        row={row}
        sx={{ gap: '0 48px' }}
        className="checkbox-radio-disabled-color"
      >
        {typeList.map((item, index) => (
          <Box>
            <FormControlLabel
              key={index}
              sx={{
                minWidth:
                  index === typeList.length - 1 && lWidth ? lWidth : '102px',
              }}
              disabled={queryType === 'detail'}
              value={item.value}
              control={<Radio />}
              label={item.label}
            />
            {Array.isArray(children) && children.length > 0 && children[index]}
          </Box>
        ))}
      </RadioGroup>
    );
  },
);

export const CheckBoxFieldCom = forwardRef(
  (
    { queryType, pr, label, onCallBack, resetPrize, guid, restKey, ...props },
    ref,
  ) => {
    return (
      <FormControlLabel
        ref={ref}
        {...props}
        {...pr}
        variant="standard"
        checked={pr.value ?? false}
        control={<Checkbox color="primary" />}
        label={label && <Box color="#000">{label}</Box>}
        onChange={(e) => {
          onCallBack && onCallBack();
          resetPrize && resetPrize(guid, restKey, e.target.checked);
          pr.onChange(e.target.checked);
        }}
        disabled={queryType === 'detail'}
      />
    );
  },
);

export const UploadImageCom = forwardRef(
  (
    {
      multiple = false,
      uW = '120',
      uH = '120',
      iW = '120',
      iH = 'auto',
      maxNumber = 9,
      images = [],
      handleSetImages,
      label,
      required = false,
      tips,
      tipsAlign = 'left',
      handlePreview,
      queryType,
      acceptType = ['png'],
    },
    ref,
  ) => {
    const theme = useTheme();
    const onChange = (imageList) => {
      // data for submit
      handleSetImages(imageList);
    };
    return (
      <Box ref={ref} sx={{ width: '100%' }}>
        {label && (
          <Box mb={2} color="#212100" fontSize="12px">
            {required && <span style={{ color: 'red' }}>*</span>} {label}
          </Box>
        )}
        <ImageUploading
          multiple={multiple}
          value={images}
          onChange={onChange}
          maxNumber={maxNumber}
          dataURLKey="data_url"
          acceptType={acceptType}
        >
          {({
            // imageList,
            onImageUpload,
            // onImageRemoveAll,
            onImageUpdate,
            // onImageRemove,
            // isDragging,
            dragProps,
          }) => (
            // write your building UI
            <Box sx={{ width: '100%', height: '100%' }}>
              {images.length === 0 && queryType !== 'detail' && (
                <Box
                  sx={{
                    width: `${uW}px`,
                    height: `${uH}px`,
                    background: '#F5F5F5',
                    borderRadius: '4px',
                    border: '1px solid #CCCCCC',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  onClick={onImageUpload}
                  {...dragProps}
                >
                  {/* <img src={AddPhoto} alt="" width="38" /> */}
                  {/* <AddPhoto sx={{ width: '38px', height: '38px' }} /> */}
                  <SvgIconML
                    name="add_photo_alternate"
                    size={38}
                    className="preview"
                  />
                </Box>
              )}
              {images.map((image, index) => (
                <Box
                  key={index}
                  className="upload-image-item"
                  sx={{
                    width: `${iW}px`,
                    height: `${iH}px`,
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: '4px',
                    border: '1px solid #cccccc',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    src={image['data_url']}
                    alt=""
                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                  />
                  <Card className="montmorillonite-layer-wrap"></Card>
                  <Card className="montmorillonite-layer-in">
                    <Box className="icon-wrap">
                      <IconButton
                        className="icon-button"
                        aria-label="edit"
                        onClick={() => handlePreview(images)}
                        //  onClick={onEdit}
                      >
                        <SvgIconML
                          name="imgPreview"
                          size={24}
                          fill={theme.palette.primary.main}
                        />
                      </IconButton>
                    </Box>
                    {queryType !== 'detail' && (
                      <Box className="icon-wrap">
                        {/* <UpdateIcon
                        size={24}
                          className="icon-style"
                          onClick={() => onImageUpdate(index)}
                        /> */}
                        <IconButton
                          className="icon-button"
                          aria-label="edit"
                          onClick={() => onImageUpdate(index)}
                        >
                          <SvgIconML
                            name="updateImg"
                            size={24}
                            fill={theme.palette.primary.main}
                          />
                        </IconButton>
                      </Box>
                    )}
                  </Card>
                </Box>
              ))}
            </Box>
          )}
        </ImageUploading>
        {tips && queryType !== 'detail' && (
          <Box mt={0.5} color="#999999" fontSize="12px" textAlign={tipsAlign}>
            {tips}
          </Box>
        )}
      </Box>
    );
  },
);
